/* global SVP */
'use strict';

var Sizzle = require('sizzle');
import * as domUtils from '../util/dom';
var device = require('../util/device');
var VideoConfig = require('../config');

import * as UIConstants from './ui/ui-constants';

var UIPlayButton = require('./ui/play-button');
var UILanguageButton = require('./ui/language-button');
var UIFullscreenButton = require('./ui/fullscreen-button');
var UIVolumeControls = require('./ui/volume-controls');
var UITimelineControls = require('./ui/timeline-controls');

var CLASSNAMES = {
	buttonContainer: 'svp_js-buttons',
	buttonContainerButton: 'svp_ui-buttons__button',
	controlsContainer: 'svp_js-controls',
	play: 'svp_js-controls-btn--play',
	uiContainer: 'svp_js-ui',
    toggleTabIndex: 'svp_js-togg-tab-index',
    loader: 'svp_js-loader'
};

var STATE_CLASS = UIConstants.STATE_CLASS;

var PLAYING_STATE = UIConstants.PLAYING_STATE;

var NAMESPACE = 'svtUI';

module.exports = {
	namespace: NAMESPACE,
	create: function (api) {

		if (!api.config.controls) {
			return;
		}

		const uiPlayButton = UIPlayButton.create(api);
		const uiTimelineControls = UITimelineControls.create(api);
		const uiFullscreenButton = UIFullscreenButton.create(api);
		const uiVolumeControls = UIVolumeControls.create(api);
        const uiLanguageButton = UILanguageButton.create(api);

        domUtils.addClass(uiPlayButton, CLASSNAMES.toggleTabIndex);
        domUtils.addClass(uiTimelineControls, CLASSNAMES.toggleTabIndex);
        domUtils.addClass(uiFullscreenButton, CLASSNAMES.toggleTabIndex);
        domUtils.addClass(uiVolumeControls, CLASSNAMES.toggleTabIndex);

        let _uiFadeTimeout;

		var FADE_INTERVAL_SHORT = 10,
			FADE_INTERVAL_MEDIUM = 3000,
			FADE_INTERVAL_LONG = 10000,
			_isEventsBound = false,
			_isVideoStarted = false,
			_isVideoPlaying = false,
			_isVideoPaused = false,
			_isVideoBuffering = false,
			_isControlsVisible = false,
			_isTouchClick = false,
			_isTouchDown = false,
			_isTouchMove = false,
            _isManualFocus = false,
			_isInFocus = false,
            _isMouseOver = false,
			_useExternalUi = false,
			_prevState = PLAYING_STATE.paused;


		function _getElement(className) {
			return Sizzle('.' + className, api.element())[0];
		}

		function _createVideoControls() {

			var controls = domUtils.fromString(`<div class="svp_ui svp_js-ui">
					<div class="svp_ui-buttons svp_js-buttons svp_is--initial-ui"></div>
					<div class="svp_ui-controls-container">
						<div class="svp_ui-controls svp_js-controls svp_is--initial-ui"></div>
					</div>
					<div class="svp_ui-loader svp_js-loader">
					    <span class="svp_ui-loader__spinner"></span>
                    </div>
				</div>`
			);

			if (SVP._cssNotLoadedClass) {
				domUtils.addClass(controls, SVP._cssNotLoadedClass);
				controls.style.visibility = 'hidden';
			}

			var controlsNode = Sizzle('.svp_js-controls', controls)[0],
				playButton = uiPlayButton.createElement(),
				timelineControls = uiTimelineControls.createElement(),
				languageButton = uiLanguageButton.createElement(),
				fullscreenButton = uiFullscreenButton.createElement();

			controlsNode.appendChild(playButton);
			controlsNode.appendChild(timelineControls);

			if (_includeVolumeControls()) {
				controlsNode.appendChild(uiVolumeControls.createElement());
			}

			controlsNode.appendChild(languageButton);
			controlsNode.appendChild(fullscreenButton);

			domUtils.addClass(fullscreenButton, UIConstants.PROPERTY_CLASS.isLast);

			return controls;
		}

		function _includeVolumeControls() {
			return !device.isIOS();
		}

		function _buildVideoUI() {
			var tabFocusElement = domUtils.fromString('<div class="svp_ui-tabfocus ' + UIConstants.FOCUS_ELEMENT_CLASS + '" tabindex="-1" aria-label="Videospelare">Videospelare</div>');
			var controlsElement = _createVideoControls();

			api.element().appendChild(tabFocusElement);
			api.element().appendChild(controlsElement);

			_setTabIndex(false);
			var uiContainer = _getElement(CLASSNAMES.uiContainer);

			if (!VideoConfig.splash) {
				domUtils.removeClass(Sizzle('.' + STATE_CLASS.initialUi, uiContainer), STATE_CLASS.initialUi);
				domUtils.addClass(uiContainer, STATE_CLASS.visible);
			}
		}

		function _setTabIndex(shouldSet) {
			var controlsContainer = _getElement(CLASSNAMES.controlsContainer),
				index = shouldSet ? '0' : '-1',
				items;
			if (controlsContainer) {
				items = Sizzle('.' + CLASSNAMES.toggleTabIndex, controlsContainer);
				for (var i = 0; i < items.length; i++) {
					items[i].setAttribute('tabindex', index);
				}
			}
		}

		function _fadeOutFn(force) {
			var uiContainer = _getElement(CLASSNAMES.uiContainer);
			if (!(uiContainer && api.data())) {
				return;
			}

			if (api.data().allowNoUi && (force || !(_isVideoPaused || _isVideoBuffering || _isTouchDown || _isInFocus))) {
				_setTabIndex(false);
				domUtils.removeClass(uiContainer, STATE_CLASS.visible);
                uiLanguageButton.destroyDialog();
				setTimeout(function () {
					_isControlsVisible = false;
					if (api.fire) {
						api.fire('controls', { visible: false });
					}
					domUtils.addClass(uiContainer, UIConstants.PROPERTY_CLASS.hideCursor);
				}, 200);
			}
		}

        function _fadeInFn(fadeOutInterval) {
            fadeOutInterval = fadeOutInterval || FADE_INTERVAL_MEDIUM;
            clearTimeout(_uiFadeTimeout);
            var uiContainer = _getElement(CLASSNAMES.uiContainer);
            if (!uiContainer) {
                return;
            }

            _setTabIndex(true);
            domUtils.removeClass(uiContainer, UIConstants.PROPERTY_CLASS.hideCursor);
            domUtils.addClass(uiContainer, STATE_CLASS.visible);
            setTimeout(function () {
                _isControlsVisible = true;
                if (api.fire) {
                    api.fire('controls', { visible: true });
                }
            }, 200);
            _uiFadeTimeout = setTimeout(_fadeOutFn, fadeOutInterval);
        }

		function _setPlayingState(state, what) {
			if (state === PLAYING_STATE.error) {
				uiPlayButton.setState('error', what);
			} else {
				if (!_isVideoStarted && state === PLAYING_STATE.playing) {
                    domUtils.removeClass(Sizzle('.' + STATE_CLASS.initialUi, Sizzle('.' + CLASSNAMES.uiContainer, api.element())[0]), STATE_CLASS.initialUi);
					_isVideoStarted = true;
                    _fadeInFn();
				}

				_isVideoPlaying = state === PLAYING_STATE.playing;
				_isVideoPaused = state === PLAYING_STATE.paused;
				_isVideoBuffering = state === PLAYING_STATE.loading;

				const loader = Sizzle('.' + CLASSNAMES.loader, api.element())[0];
				if (_isVideoStarted && _isVideoBuffering) {
                    domUtils.addClass(loader, 'svp_ui-loader--loading');
                } else {
                    domUtils.removeClass(loader, 'svp_ui-loader--loading');

                    //hide ui if we've been in buffer state but no longer is in mouse over mode
                    if (!_isMouseOver && _isVideoStarted) {
                        clearTimeout(_uiFadeTimeout);
                        _uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_MEDIUM);
                    }
                }

				if (!_isVideoBuffering) {
					_prevState = state;
				}
			}
		}

		function _resetUi(clearAll) {
			_isVideoStarted = false;
			_isVideoBuffering = false;
			clearTimeout(_uiFadeTimeout);
			_uiFadeTimeout = null;

			var controlsContainer = _getElement(CLASSNAMES.controlsContainer);
			domUtils.removeClass(controlsContainer, STATE_CLASS.error);

			if (VideoConfig.splash) {
				domUtils.addClass(controlsContainer, STATE_CLASS.hidden);
			}

			uiTimelineControls.reset();
			uiPlayButton.reset();

			if (clearAll) {
				uiLanguageButton.reset();
			}

			domUtils.addClass(controlsContainer, STATE_CLASS.initialUi);
		}

        /*function _focusVideo() {
            var tabFocusElement = Sizzle('.' + CLASSNAMES.tabFocus, api.element())[0];

            tabFocusElement.setAttribute('tabindex', 0);
            _isManualFocus = true;
            tabFocusElement.focus();
            _isManualFocus = false;
        }*/

		function _addVideoEventListeners() {
			var setLoading = _setPlayingState.bind(this, PLAYING_STATE.loading);
			api.on(NAMESPACE + '.play', setLoading);
			api.on(NAMESPACE + '.buffering', setLoading);
			api.on(NAMESPACE + '.seeking', setLoading);

			api.on(NAMESPACE + '.seeked', function () {
				_setPlayingState(_prevState);
			});

			api.on(NAMESPACE + '.canplay', function () {
				_setPlayingState(PLAYING_STATE.paused);
			});

			api.on(NAMESPACE + '.playing', function () {
				_setPlayingState(PLAYING_STATE.playing);

				// fade timeout is cleared on reset, meaning we need to re-set it if we're playing multiple videos in a row
				if (!_uiFadeTimeout) {
					_uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_SHORT);
				}
			});

			api.on(NAMESPACE + '.pause', function () {
				_setPlayingState(PLAYING_STATE.paused);
				_fadeInFn();
			});
		}

		function _setupControlEvents() {
			var controlsMouseOverFn = function () {
                    _isMouseOver = true;
					if (_isVideoStarted) {
						_fadeInFn();
					}
				},
				controlsMouseOutFn = function () {
                    _isMouseOver = false;
					if (_isVideoStarted) {
						clearTimeout(_uiFadeTimeout);
						_uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_SHORT);
					}
				};
			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'mouseover', controlsMouseOverFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.buttonContainer), 'mouseover', controlsMouseOverFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'mousemove', _fadeInFn.bind(this, FADE_INTERVAL_LONG), NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'mouseout', controlsMouseOutFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.buttonContainer), 'mouseout', controlsMouseOutFn, NAMESPACE);

			var togglePlayFn = function (e) {
                e.preventDefault();

				uiPlayButton.togglePlay();

				return false;
			};

			var toggleUiFn = function () {
				if (_isControlsVisible) {
					_fadeOutFn();
				} else {
					_fadeInFn();
				}
			};

			domUtils.addEvents(_getElement(CLASSNAMES.uiContainer), 'click', togglePlayFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.uiContainer), 'touchend', function (e) {
				_isTouchDown = false;
				if (e.cancelable) {
					e.preventDefault();
				}
				if (_isTouchMove) {
					_isTouchMove = false;

					return;
				}
                _isInFocus = false;
                toggleUiFn();
			}, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.uiContainer), 'touchmove', function () {
				_isTouchMove = true;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'touchstart', function () {
				_isTouchClick = true;
				_isTouchDown = true;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'touchend', function () {
				_isTouchDown = false;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'click', function (e) {
				if (_isTouchClick) {
					toggleUiFn(e);
				} else {
					togglePlayFn(e);
				}
				_isTouchClick = false;
			}, NAMESPACE);

            domUtils.addEvents(api.element(), 'mousedown', function () {
                api.element().setAttribute('tabindex', '0');
                _getElement(UIConstants.FOCUS_ELEMENT_CLASS).removeAttribute('tabindex');
            }, NAMESPACE);

            domUtils.addEvents(api.element(), 'blur', function () {
                api.element().removeAttribute('tabindex');
                _getElement(UIConstants.FOCUS_ELEMENT_CLASS).setAttribute('tabindex', '0');
            }, NAMESPACE);

			domUtils.addEvents(_getElement(UIConstants.FOCUS_ELEMENT_CLASS), 'focusin', function () {
                if (!_isManualFocus) {
                    _fadeInFn();
                    _isInFocus = true;
                }
			}, NAMESPACE);

			domUtils.addEvents(_getElement(UIConstants.FOCUS_ELEMENT_CLASS), 'focusout', function () {
				_isInFocus = false;
				setTimeout(function () {
					if (!_isInFocus) {
						_fadeOutFn();
					}
				}, 250);
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'focusin', function () {
				_isInFocus = true;
			}, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.controlsContainer), 'focusout', function (e) {
				_isInFocus = false;
				if (!e.dialogFocusOut) {
                    setTimeout(function () {
                        if (!_isInFocus) {
                            _fadeOutFn();
                        }
                    }, 250);

                }
			}, NAMESPACE);
		}

		function _bindUiInteractionEvents() {
			if (!device.isTouch()) {
                const controlsMouseOverFn = () => {
                    _isMouseOver = true;
                    if (_isVideoStarted) {
                        _fadeInFn(FADE_INTERVAL_MEDIUM);
                    }
                };

                const controlsMouseOutFn = () => {
                    _isMouseOver = false;
                    if (_isVideoStarted) {
                        clearTimeout(_uiFadeTimeout);
                        _uiFadeTimeout = setTimeout(_fadeOutFn, FADE_INTERVAL_SHORT);
                    }
                };

				api.element().addEventSVP('mousemove', controlsMouseOverFn);
                api.element().addEventSVP('mouseout', controlsMouseOutFn);
			}

			_setupControlEvents();

			uiPlayButton.bindEvents(api);
			uiFullscreenButton.bindEvents(api);
			uiTimelineControls.bindEvents(api);
			uiLanguageButton.bindEvents(api);

			if (_includeVolumeControls()) {
				uiVolumeControls.bindEvents(api);
			}

			api.on('showControls', function (e) {
				if (_isVideoStarted) {
					if (e.detail.shouldShow) {
						_fadeInFn();
					} else {
						_fadeOutFn();
					}
				}
			});

			api.on('languageDialog', (event) => {
                const uiContainer = _getElement(CLASSNAMES.uiContainer);
			    if (event.detail.visible) {
                    domUtils.addClass(uiContainer, 'svp_ui--language-dialog-visible');
                } else {
                    domUtils.removeClass(uiContainer, 'svp_ui--language-dialog-visible');
                }
            });
		}

		function _bindEvents() {
			if (!_isEventsBound) {
				_addVideoEventListeners();
				_bindUiInteractionEvents();

				api.on(NAMESPACE + '.ready', function (data) {
					_useExternalUi = data.detail.externalUi;
				});

				_isEventsBound = true;
			}

			api.once(NAMESPACE + '-bind.playing', function () {
				var controlsContainer = _getElement(CLASSNAMES.controlsContainer);
				domUtils.removeClass(controlsContainer, STATE_CLASS.hidden);
				var uiContainer = Sizzle('.' + CLASSNAMES.uiContainer, api.element())[0];

				if (_useExternalUi) {
					// TODO this 'else'-clause is for chromecast-with-HDS-video, and should be removed once the flash player isn't used any more.
					if (api.data().allowNoUi) {
						domUtils.addClass(uiContainer, STATE_CLASS.externalUi);
					} else {
						domUtils.addClass(Sizzle('.' + CLASSNAMES.controlsContainer, api.element())[0], STATE_CLASS.animatable);
						_fadeInFn();
					}
				} else {
					domUtils.removeClass(uiContainer, STATE_CLASS.externalUi);
					domUtils.addClass(controlsContainer, STATE_CLASS.animatable);
				}
			});
		}

		_buildVideoUI();

		api.filters.push({
			load: function (videoId, autoplay) {
				_resetUi(true);
				_bindEvents();

				if (VideoConfig.splash) {
					_fadeOutFn(true);
				}

				return false;
			},
			insertButton: function (domElement) {
				var buttonRow = Sizzle('.' + CLASSNAMES.buttonContainer, api.element())[0];

				if (buttonRow) {
					domUtils.addClass(domElement, CLASSNAMES.buttonContainerButton);
					if (buttonRow.firstChild) {
						buttonRow.insertBefore(domElement, buttonRow.firstChild);
					} else {
						buttonRow.appendChild(domElement);
					}
				}
			},
			reset: function () {
				_resetUi(false);
				if (VideoConfig.splash) {
					_fadeOutFn(true);
					api.once(NAMESPACE + '-bind.playing', function () {
						var controlsContainer = _getElement(CLASSNAMES.controlsContainer);
						domUtils.removeClass(controlsContainer, STATE_CLASS.hidden);
					});
				}
			}
		});

	},
	destroy: function (api) {
		var element = Sizzle('.' + CLASSNAMES.uiContainer, api.element())[0],
			tabFocusElement = Sizzle('.' + UIConstants.FOCUS_ELEMENT_CLASS, api.element())[0];

		if (element) {
			UIPlayButton.destroy(api);
			UITimelineControls.destroy(api);
			UILanguageButton.destroy(api);
			UIFullscreenButton.destroy(api);
			UIVolumeControls.destroy(api);

			element.parentElement.removeChild(element);
			tabFocusElement.parentElement.removeChild(tabFocusElement);
		}
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/ui.js